var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('my-title',[_vm._v("ToDo List")]),_c('my-card',[_c('my-input',{on:{"newTask":_vm.addNewTask}}),_c('post-list',{attrs:{"tasks":_vm.$tasksFiltered},on:{"remove":_vm.removeItem,"checkIt":_vm.checkIt}}),_c('my-footer',{attrs:{"total":_vm.$tasks[_vm.$currentTabIndex].length}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }